// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {
			//Event click menus
		$('li.menu-item-tab').on('click',function(){
			location.hash=$(this).data('menuname').toLowerCase().replace(" ",'_');
		});

		if(location.pathname.indexOf('/menus')>-1 && location.hash.length>0){
			let hashTittle = titleCase(location.hash.replace('_',' ').replace('#','')).replace(' ','.')
			$('li.menu-item-tab.js-menu-tab.'+hashTittle).trigger('click')
		}

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});
		
		setTimeout(function () {
			$('.top-content-lines').addClass('show-object');
		}, 500);
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})

		if(location.pathname == '/gallery') {
			$('#content').append("<div class='hide-object lines container'></div>")
		};
		
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
		
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}